import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
export var SelectButtonLabel = /*#__PURE__*/function (_React$Component) {
  _inherits(SelectButtonLabel, _React$Component);

  var _super = _createSuper(SelectButtonLabel);

  function SelectButtonLabel() {
    _classCallCheck(this, SelectButtonLabel);

    return _super.apply(this, arguments);
  }

  _createClass(SelectButtonLabel, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          value = _this$props.value,
          options = _this$props.options;
      var placeholder = this.props.placeholder || null;

      if (!value) {
        return placeholder || null;
      }

      if (!Array.isArray(value)) {
        var option = options.find(function (option) {
          return option.value === value;
        });
        return option ? option.label : placeholder;
      }

      return options.reduce(function (labels, option) {
        if (value.includes(option.value)) {
          return [].concat(_toConsumableArray(labels), [option.label]);
        }

        return labels;
      }, []).join(', ') || placeholder;
    }
  }]);

  return SelectButtonLabel;
}(React.Component);